<template>
  <div class="d-flex justify-center align-center">
    <v-img
      max-height="150"
      max-width="150"
      src="/assets/image/logo-animation.gif"
    ></v-img>
  </div>
</template>

<script>
  import constantsKey from '@/core/filters/constants-key.filter';
  import { DEVICE_TYPE } from '@/core/constants/enums';
  import { LOCAL } from '@/core/constants';
  import { uiHelper } from '@/core/utils';
  import {
    CONSTANTS_GET_CONSTANTS,
    CONSTANTS_INITIAL_CONSTANTS_STATE
  } from '@/core/store/constants.module';
  import {
    LOOKUP_GET_GLOBAL_SETTING,
    LOOKUP_INITIAL_GET_GLOBAL_SETTING_STATE
  } from '@/core/store/lookup.module';

  export default {
    name: 'QRLink',
    data: () => ({
      qrCodeURL: null
    }),
    computed: {
      constantsComplete() {
        return this.$store.state.constants.constants.complete;
      },
      globalSettingComplete() {
        return this.$store.state.lookup.globalSetting.complete;
      }
    },
    watch: {
      constantsComplete() {
        let response = this.$store.state.constants.constants;

        if (response.complete) {
          this.constantsCompleteAction(response);
        }
      },
      globalSettingComplete() {
        let response = this.$store.state.lookup.globalSetting;

        if (response.complete) {
          this.globalSettingCompleteAction(response);
        }
      }
    },
    created() {
      this.initQRLink();
    },
    methods: {
      globalSettingCompleteAction(response) {
        if (response.code == 0) {
          uiHelper.openPage(response.data.url, '_self');
        } else {
          console.log(response);
        }

        this.initialGetGlobalSettingState();
      },
      constantsCompleteAction(response) {
        if (response.code == 0) {
          this.getQRCodeURL();
        } else {
          console.log(response);
        }
        this.initialGetConstantsState();
      },
      getQRCodeURL() {
        let clientDeviceOS = uiHelper.getOperatingSystem();
        let key = DEVICE_TYPE.ANDROID;

        if (['Macintosh', 'IOS'].includes(clientDeviceOS)) {
          key = DEVICE_TYPE.IOS;
        } else if (['Linux', 'Android', 'Windows'].includes(clientDeviceOS)) {
          key = DEVICE_TYPE.ANDROID;
        } else if (['Huawei'].includes(clientDeviceOS)) {
          key = DEVICE_TYPE.HUAWEI;
        }

        let platformKey = constantsKey('deviceType', key);

        let data = {
          platform: platformKey
        };

        this.getGlobalSetting(data);
      },
      getGlobalSetting(data) {
        this.$store.dispatch(LOOKUP_GET_GLOBAL_SETTING, { data });
      },
      initialGetGlobalSettingState() {
        this.$store.dispatch(LOOKUP_INITIAL_GET_GLOBAL_SETTING_STATE);
      },
      getConstants() {
        this.$store.dispatch(CONSTANTS_GET_CONSTANTS);
      },
      initialGetConstantsState() {
        this.$store.dispatch(CONSTANTS_INITIAL_CONSTANTS_STATE);
      },
      initQRLink() {
        let constantsData = JSON.parse(
          uiHelper.getLocalStorage(LOCAL.CONSTANTS)
        );

        if (constantsData) {
          this.getQRCodeURL();
        } else {
          this.getConstants();
        }
      }
    }
  };
</script>

<style></style>
